"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CancelChangesPrompt = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var core_1 = require("@material-ui/core");
var react_1 = __importDefault(require("react"));
var Dialog_1 = require("../Dialog");
exports.CancelChangesPrompt = react_1.default.memo(function (_a) {
    var onCancel = _a.onCancel, onContinue = _a.onContinue, open = _a.open, message = _a.message, cancelButtonId = _a.cancelButtonId, continueButtonId = _a.continueButtonId;
    return ((0, jsx_runtime_1.jsx)(Dialog_1.Dialog, __assign({ title: "Are you sure...", open: !!open, actions: (0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(core_1.Button, __assign({ id: cancelButtonId, variant: "contained", color: "primary", onClick: function () { return onCancel(); }, "data-testid": cancelButtonId }, { children: "Cancel" })), (0, jsx_runtime_1.jsx)(core_1.Button, __assign({ id: continueButtonId, variant: "contained", color: "primary", onClick: function () { return onContinue(); }, "data-testid": continueButtonId }, { children: "Continue" }))] }) }, { children: message })));
});
